import BaseApi from './baseApi';
export default class DataManagementApi extends BaseApi {
    constructor() {
        super("datamanagement", "NoticeOfLoss");
    }

    async DeleteInboundsNoticeOfLossDetail(id: string) : Promise<boolean> {
        const json = this.getJsonDeleteNoticeOfLoss(id);
        const response = await this.api.post('deleteInboundNoticeOfLoss', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteNoticeOfLoss(id: string) : any {
        const json = {
            "IdNoticeOfLossDetail": id
        };
        return json;
    }
}
